import {rgbToArray} from "./index";

export const TRANSPARENT_COLOR = [255, 255, 255, 1];
export const MINT_COLOR = [168, 215, 229, 200];

// http://colorbrewer2.org/#type=sequential&scheme=YlOrRd&n=9

export const PALETTE_YlOrRd_9 = [
  rgbToArray('#ffffccc8'),
  rgbToArray('#ffeda0c8'),
  rgbToArray('#fed976c8'),
  rgbToArray('#feb24cc8'),
  rgbToArray('#fd8d3cc8'),
  rgbToArray('#fc4e2ac8'),
  rgbToArray('#e31a1cc8'),
  rgbToArray('#bd0026c8'),
  rgbToArray('#800026c8'),
];

export const PALETTE_OrRd_9 = [
  rgbToArray('#fff7ecc8'),
  rgbToArray('#fee8c8c8'),
  rgbToArray('#fdd49ec8'),
  rgbToArray('#fdbb84c8'),
  rgbToArray('#fc8d59c8'),
  rgbToArray('#ef6548c8'),
  rgbToArray('#d7301fc8'),
  rgbToArray('#b30000c8'),
  rgbToArray('#7f0000c8')
];

export const PALETTE_YlGnBu_9 = [
  rgbToArray('#ffffd9c8'),
  rgbToArray('#edf8b1c8'),
  rgbToArray('#c7e9b4c8'),
  rgbToArray('#7fcdbbc8'),
  rgbToArray('#41b6c4c8'),
  rgbToArray('#1d91c0c8'),
  rgbToArray('#225ea8c8'),
  rgbToArray('#253494c8'),
  rgbToArray('#081d58c8'),
];

export const PALETTE_PuBu_9 = [
  rgbToArray('#fff7fbc8'),
  rgbToArray('#ece7f2c8'),
  rgbToArray('#d0d1e6c8'),
  rgbToArray('#a6bddbc8'),
  rgbToArray('#74a9cfc8'),
  rgbToArray('#3690c0c8'),
  rgbToArray('#0570b0c8'),
  rgbToArray('#045a8dc8'),
  rgbToArray('#023858c8'),
];

export const PALETTE_YlGn_9 = [
  rgbToArray('#ffffe5c8'),
  rgbToArray('#f7fcb9c8'),
  rgbToArray('#d9f0a3c8'),
  rgbToArray('#addd8ec8'),
  rgbToArray('#78c679c8'),
  rgbToArray('#41ab5dc8'),
  rgbToArray('#238443c8'),
  rgbToArray('#006837c8'),
  rgbToArray('#004529c8'),
];

export const PALETTE_RdPu_9 = [
  rgbToArray('#fff7f3c8'),
  rgbToArray('#fde0ddc8'),
  rgbToArray('#fcc5c0c8'),
  rgbToArray('#fa9fb5c8'),
  rgbToArray('#f768a1c8'),
  rgbToArray('#dd3497c8'),
  rgbToArray('#ae017ec8'),
  rgbToArray('#7a0177c8'),
  rgbToArray('#49006ac8'),
];

// 에메랄드 ~ 아쿠아블루
export const PALETTE_GnBu_9 = [
  rgbToArray('#f7fcf0c8'),
  rgbToArray('#e0f3dbc8'),
  rgbToArray('#ccebc5c8'),
  rgbToArray('#a8ddb5c8'),
  rgbToArray('#7bccc4c8'),
  rgbToArray('#4eb3d3c8'),
  rgbToArray('#2b8cbec8'),
  rgbToArray('#0868acc8'),
  rgbToArray('#084081c8'),
]

// 구분 잘 되도록
export  const PALETTE_VIVID =[
  rgbToArray('#0057A0c8'),
  rgbToArray('#0077C0c8'),
  rgbToArray('#1297E0c8'),
  rgbToArray('#19B5FEc8'),
  rgbToArray('#FFAC9Cc8'),
  rgbToArray('#FF8C7Cc8'),
  rgbToArray('#FF6C5Cc8'),
  rgbToArray('#E74C3Cc8'),
  rgbToArray('#C72C1Cc8'),
]

// 흑백
export const PALETTE_Greys_9 = [
  rgbToArray('#ffffffc8'),
  rgbToArray('#f0f0f0c8'),
  rgbToArray('#d9d9d9c8'),
  rgbToArray('#bdbdbdc8'),
  rgbToArray('#969696c8'),
  rgbToArray('#737373c8'),
  rgbToArray('#525252c8'),
  rgbToArray('#252525c8'),
  rgbToArray('#000000c8'),
];


export const getColorsFromPalettes = (index) => {
  const palettes = [
    PALETTE_YlOrRd_9,
    PALETTE_OrRd_9,
    PALETTE_YlGnBu_9,
    PALETTE_PuBu_9,
    PALETTE_YlGn_9,
    PALETTE_RdPu_9,
    PALETTE_GnBu_9,
    // PALETTE_Greys_9,
  ];

  return palettes.map(palette => palette[index]);
};


// 대표 컬러
export const PALETTE_DEFAULT = PALETTE_YlOrRd_9;
